import { render } from "./App.vue?vue&type=template&id=60640cfa"
const script = {}

import "./App.vue?vue&type=style&index=0&id=60640cfa&lang=css"

import exportComponent from "/builds/gh_prod_devops/gh_prod_devops_web/risk_prod_deploy/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__